import { Receipt, FileCheck, FileMinus, RefreshCw, Megaphone, Users, Briefcase, Package, BarChart3, Bell, Camera, BookUser, CalendarRange, CalendarDays, ListChecks } from "lucide-react";

export const TABS = [
  { key: "invoices", label: "Factures", to: "/documents/invoice", icon: Receipt },
  { key: "quotes", label: "Devis", to: "/documents/quote", icon: FileCheck },
  { key: "credits", label: "Avoirs", to: "/documents/credit", icon: FileMinus },
  { key: "recurring", label: "Récurrentes", to: "/recurring", icon: RefreshCw },
  { key: "communication", label: "Communication", to: "/communication", icon: Megaphone },
  { key: "content_calendar", label: "Calendrier de diffusion", to: "/calendrier-diffusion", icon: CalendarDays },
  { key: "clients", label: "Clients", to: "/clients", icon: Users },
  { key: "employees", label: "Employés", to: "/employes", icon: Briefcase },
  { key: "events", label: "Événements", to: "/evenements", icon: CalendarRange },
  { key: "tasks", label: "Tâches", to: "/taches", icon: ListChecks },
  { key: "expenses", label: "Notes de frais", to: "/notes-de-frais", icon: Receipt },
  { key: "catalog", label: "Produits & Services", to: "/catalogue", icon: Package },
  { key: "equipment", label: "Matériel", to: "/materiel", icon: Camera },
  { key: "directory", label: "Répertoire", to: "/repertoire", icon: BookUser },
  { key: "reports", label: "Rapports", to: "/rapports", icon: BarChart3 },
  { key: "notifications", label: "Notifications", to: "/notifications", icon: Bell },
];

export const ROLE_LABELS = {
  admin: "Administrateur",
  employe: "Employé",
  alternant: "Alternant",
  stagiaire: "Stagiaire",
};

export const ROLE_COLORS = {
  admin: "bg-purple-100 text-purple-700",
  employe: "bg-blue-100 text-blue-700",
  alternant: "bg-amber-100 text-amber-700",
  stagiaire: "bg-green-100 text-green-700",
};
